import EventDetailTeams from '@/screens/EventDetailTeams';

export default function PrivateTabsEventEventIdTeamsRoute() {
  return <EventDetailTeams basePath="/event/[eventId]" />;
}
